import { useTranslation } from "react-i18next";

import { cn } from "../../utils/cn";

export interface RouteLoaderProps {
  fullScreen?: boolean;
  className?: string;
}

export function RouteLoader({ fullScreen = false, className }: RouteLoaderProps) {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      aria-label={t("common.loading")}
      className={cn(
        "flex items-center justify-center bg-surface",
        fullScreen ? "min-h-screen" : "min-h-[50vh]",
        className,
      )}
    >
      <div className="route-loader-spinner" aria-hidden="true" />
    </div>
  );
}
